import React from 'react';
import { Skeleton } from 'fronton-react/unstable';
import {
  SkeletonRows,
  bestPriceSkeleton,
  additionalPriceSkeleton,
  priceSkeleton,
  basketSkeleton,
} from './pdp-sticky-card-panel.styles';

export const StickyCardPanelSkeleton: React.FC = () => {
  return (
    <SkeletonRows>
      <Skeleton className={bestPriceSkeleton} />
      <Skeleton className={priceSkeleton} />
      <Skeleton className={additionalPriceSkeleton} />
      <Skeleton className={basketSkeleton} />
    </SkeletonRows>
  );
};
